import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import styles from './TemplateThumbnail.module.scss';

const EMAIL_WIDTH = 600;

interface TemplateThumbnailProps {
    html: string;
    className?: string;
}

// Scaled, non-interactive render of an email (600px wide) that fits its container width.
export const TemplateThumbnail: React.FC<TemplateThumbnailProps> = ({ html, className }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [scale, setScale] = useState(0.4);

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const update = () => setScale(element.clientWidth / EMAIL_WIDTH);
        update();

        const observer = new ResizeObserver(update);
        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            className={clsx(styles.root, className)}
        >
            <iframe
                title="Template thumbnail"
                sandbox=""
                tabIndex={-1}
                srcDoc={html}
                style={{ width: EMAIL_WIDTH, height: 1000, transform: `scale(${scale})` }}
            />
        </div>
    );
};

export default TemplateThumbnail;
